export var NEW_CLIENTS_DEFAULT_WEEKS = 6;
